<style lang="sass" scoped>
.app_container
  display: flex
  flex-direction: column

::v-deep
  .van-button--primary
    height: 54px
    font-weight: bold
</style>

<style lang="sass" scoped>
.footer_common
  position: fixed
  bottom: 0
  left: 0

::v-deep
  .van-button--primary
    background-color: var(--menu-primary-background-colour)
</style>

<style lang="sass" scoped>
.form_container
  height: 100%
  width: 100%
  padding: 20px 17px 60px

.card_expiry
  position: relative
  display: flex
  justify-content: space-between

.expiry
  width: 35%

.cvv
  width: 50%

.ios_expiry
  flex: 1
  margin-right: 20px

.card-wrapper
  display: none

.left_part
  color: var(--menu-primary-background-colour)

.form
  >div
    margin-bottom: 15px
</style>

<template lang="pug">
.app_container
  .form_container
    .card-wrapper
    py-form.form(
      ref="form"
      :model="valueFields"
      :rules="ruleValidate"
    )
      .name
        py-form-item.first_name(prop='name')
          py-input(
            v-model="valueFields.name"
            title="Name"
            type="text"
            disabled
          )
      .email
        py-form-item.first_name(prop='email')
          py-input(
            v-model="valueFields.email"
            title="Email Address"
            type="email"
            maxLength="64"
            maxlength="64"
          )
      .phone
        py-form-item.first_name(prop='phone')
          py-input(
            v-model="valueFields.phone"
            title="Phone number"
            type="tel"
            @input="val => valueFields.phone = valueFields.phone.trim()"
          )
      .date
        py-form-item.first_name(prop='date')
          py-input(
            v-model="valueFields.date"
            name="first-name"
            title="Tab open date"
            type="text"
            disabled
          )
      .time
        py-form-item.first_name(prop='time')
          py-input(
            v-model="valueFields.time"
            title="Tab open time"
            type="text"
            disabled
          )
      .card_name
        py-form-item.first_name(prop='cardName')
          py-input(
            v-model="valueFields.cardName"
            title="Card Name"
            type="text"
            :disabled="disabledInput"
          )
      .card_number
        py-form-item.first_name(prop='cardNumber')
          py-input(
            v-model="valueFields.cardNumber"
            title="Card Number"
            type="text"
            name="number"
            :disabled="disabledInput"
          )
      .card_expiry
        py-form-item.expiry(
          prop='cardExpiry'
          :class="{'ios_expiry': true}"
        )
          expire-date-input(
            v-if="!isIOS"
            v-model="valueFields.cardExpiry"
            :disabled="disabledInput"
          )
          py-input(
            v-else
            name="expiry"
            v-model="valueFields.cardExpiry"
            title="Expiry (MM / YY)"
            maxlength="7"
            type="number"
            :disabled="disabledInput"
          )
        py-form-item.cvv(prop='cvc')
          py-input(
            id="cvv"
            name="cvc"
            v-model="valueFields.cvc"
            title="CVV"
            type="number"
            :disabled="disabledInput"
          )
  footer-bar.footer_common.b(
    v-if="disabledInput"
    :status="status"
    :isButton="true"
    @clickButton="handleSubmit"
  )
    template(v-slot:left v-if="")
      .left_part(@click="enablePaymentInput")
        span Change Details
  footer-common.footer_common.b(
    v-else
    :text="text"
    @clickButton="handleSubmit"
  )
  py-loading(:showLoading="showLoading")

</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import InputField from '../components/input-field'
import DateField from '../components/date-field'
import TimeField from '../components/time-field'
import CreditCardInput from '../components/CreditCardInput'
import { getTabDetail, updateTab } from 'api/tab'
import { _DateFilters, _formatCardNum, _getFormatTime, _setFormatDate, _setFormatTime, } from 'utils/format'
import { isIOS } from '@/utils/navigator'
import { t } from '@/utils/language'
import ExpireDateInput from 'components/ExpireDateInput'
import Card from 'card'

@Component({
  props: {
    venueId: {
      type: String
    },

    tabId: {
      type: [String, Number]
    }
  },

  components: {
    InputField,
    DateField,
    TimeField,
    CreditCardInput,
    ExpireDateInput,
  },
})

class TabUpdate extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  disabledInput = true
  status = 6
  isIOS = isIOS()

  // The four card rules live apart from the rest so they can be swapped out while the card on
  // file is locked and put back when the customer unlocks the fields (enablePaymentInput).
  cardRules = {
    cardNumber: [
      { required: true, message: 'Card number is required', trigger: 'blur' },
      { validator: this._validateCardNum, trigger: 'blur' },
    ],
    cardName: [
      { required: true, message: 'Card name is required', trigger: 'blur' },
    ],
    cardExpiry: [
      { required: true, message: 'Expiry is required', trigger: 'blur' },
      { validator: this._validateDate, trigger: 'blur' },
    ],
    cvc: [
      { required: true, message: 'CVV is required', trigger: 'blur' },
      { validator: this._validateCvv, trigger: 'blur' },
    ],
  }

  ruleValidate = {
    ...this.cardRules,
    name: [
      { required: true, message: 'First name is required', trigger: 'blur' },
    ],
    date: [
      { required: true, message: 'Date is required', trigger: 'blur' },
    ],
    time: [
      { required: true, message: 'Time is required', trigger: 'blur' },
    ],
    phone: [
      { validator: this._phoneNumberRule, trigger: 'blur' }
    ],
    email: [
      { required: true, message: 'Email is required', trigger: 'blur' },
      { type: 'email', message: 'Please provide a vaild email adddress', trigger: 'blur' }
    ],
  }

  showLoading = false
  text = 'SAVE'
  valueFields = {
    name: '',
    email: '',
    phone: '',
    date: '',
    time: '',
    paymentDetail: {
      expireYear: '',
      expireMonth: '',
      cvv: '',
      cardNumber: '',
    }
  }

  oldPaymentDetail = {
    expireYear: '',
    expireMonth: '',
    cvv: '',
    cardNumber: '',
  }

  enablePaymentInput() {
    this.disabledInput = false
    // the customer is entering a new card: the full card rules apply again
    this.ruleValidate = { ...this.ruleValidate, ...this.cardRules }
    this.text = t('submit', 'SUBMIT')
  }

  validateCreditCard(val) {
    const reg = /^([0-9X]{4} )([0-9X]{4} )([0-9X]{4} )([0-9X]{4})$/
    return reg.test(val)
  }

  validateYear(val) {
    if (parseInt(val) === 0) return false
    return true
  }

  validateMonth(val) {
    if ((parseInt(val) === 0) || (parseInt(val) > 12)) return false
    return true
  }

  async mounted() {
    this.$store.commit('closeLoading')
    this.showLoading = true
    await this.getTabDetails()
    this.showLoading = false
    this.$nextTick(_ => {
      // https://github.com/jessepollak/card
      var card = new Card({
        form: 'form',
        container: '.card-wrapper',
      })
    })
  }

  get tabPassCode() {
    return this.$store.state.tabPassCode.tabPassCode
  }

  _validateDate(rule, value, callback) {
    if (this.isIOS) {
      if (value.length < 7) {
        return callback(new Error('Format of expiry is incorrect'))
      }
    }
    const [getMonth, getYear] = value.split('/')
    const month = getMonth.trim()
    const year = getYear.trim()

    // 失败条件 卫语句
    // console.log(this.creditCardYearValidateFirstTime)
    if (!month) return callback(new Error('Expiry month is required'))
    if (!year && !this.creditCardYearValidateFirstTime) return callback(new Error('Expiry year is required'))
    this.creditCardYearValidateFirstTime = false

    if (parseInt(month) === 0 || parseInt(month) > 12) {
      return callback(new Error('Invaild Month'))
    }
    if (parseInt(year) === 0) {
      return callback(new Error('Invaild Year'))
    }
    return callback()
  }

  async getTabDetails() {
    let paymentDetail

    const tabDetail = await this._postTabDetail()
    if (tabDetail.paymentDetail) {
      tabDetail.paymentDetail.cardNumber = _formatCardNum(tabDetail.paymentDetail.cardNumber)
      tabDetail.openDateTime.date = _DateFilters(tabDetail.openDateTime.date)
      tabDetail.openDateTime.time = _getFormatTime(tabDetail.openDateTime.time)
      tabDetail.paymentDetail.cardExpiry = tabDetail.paymentDetail.expireMonth + ' / ' + tabDetail.paymentDetail.expireYear
      const { token, ...paymentDetails } = tabDetail.paymentDetail
      paymentDetail = paymentDetails
    } else {
      paymentDetail = {
        name: tabDetail.name,
        type: 'credit-card'
      }
    }
    this.valueFields = {
      name: tabDetail.name,
      email: tabDetail.email,
      phone: tabDetail.phone,
      date: tabDetail.openDateTime.date,
      time: tabDetail.openDateTime.time,
      minAmount: tabDetail.minAmount,
      tabAmount: tabDetail.tabAmount,
      cardNumber: paymentDetail.cardNumber,
      cvc: paymentDetail.cvc,
      cardName: paymentDetail.name,
      cardExpiry: paymentDetail.cardExpiry
    }
    this.oldPaymentDetail = JSON.parse(JSON.stringify(tabDetail.paymentDetail))
    // Card on file: since backend migration wave 2 (2026-09-10) the response carries neither the
    // reusable token nor the CVC, only the masked card number. The masked number is the signal
    // (token kept for older backends). The card fields stay locked, so the card rules must not
    // run — there is no CVC to type into a locked field; the saved card is sent back as is.
    this.disabledInput = !!(this.oldPaymentDetail.token || this.oldPaymentDetail.cardNumber)
    if (this.disabledInput) {
      this.ruleValidate = { ...this.ruleValidate, ...this._lockedCardRules() }
    }
  }

  /**
   * Rules for the four card fields while the card on file is locked: always pass, but still call
   * back. NOT an empty array — PyFormItem returns early on empty rules without calling back, and
   * PyForm.validate() only resolves once every field has called back, so an empty rule set would
   * leave the save button spinning forever (found in review, 2026-09-10).
   */
  _lockedCardRules() {
    const pass = (rule, value, callback) => callback()
    return {
      cardNumber: [{ validator: pass, trigger: 'blur' }],
      cardName: [{ validator: pass, trigger: 'blur' }],
      cardExpiry: [{ validator: pass, trigger: 'blur' }],
      cvc: [{ validator: pass, trigger: 'blur' }],
    }
  }

  handleSubmit() {
    this.showLoading = true
    const detail = this._setDetail()
    this.$refs.form.validate(async result => {
      if (!result) {
        this.showLoading = false
        return
      }
      if (this.oldPaymentDetail) {
        if ((this.oldPaymentDetail.cardNumber === this.valueFields.cardNumber)) {
          if (this.oldPaymentDetail.token) detail.paymentDetail.token = this.oldPaymentDetail.token
        } else {
          delete detail.paymentDetail?.token
        }
      }
      try {
        const res = await updateTab({
          tabId: this.tabId,
          venueId: this.venueId,
          passCode: this.tabPassCode,
          action: 'update',
          detail,
        })
        this.showLoading = false
        this.jumpToMenu()
      } catch (error) {
        this.showLoading = false
      }
    })
  }

  _phoneNumberRule(rule, value, callback) {
    value = value.trim()
    const reg = /^\d{1,}$/
    if (isNaN(value)) {
      callback(new Error('PhoneNumber format is incorrect'))
    }
    if (!reg.test(value)) {
      callback(new Error('Please enter your phone number'))
    }
    if (value.length < 6) {
      callback(new Error('PhoneNumber is greater than 6'))
    }
    if (value.length > 14) {
      callback(new Error('PhoneNumber is greater less than 14'))
    }
    callback()
  }

  _validateCvv(rule, value, callback) {
    if (value.length < 3) {
      callback(new Error('Cvv is not correct'))
    }
    callback()
  }

  _validateCardNum(rule, value, callback) {
    const cardNum = value.replace(/\s+/g, '')
    console.log({
      cardNum: value
    })
    if (value.length === 19) {
      callback()
    } else if (value.length === 16 && !value.trim().includes(' ')) {
      callback()
    } else if (cardNum.length === 15) {
      callback()
    } else {
      callback(new Error('Incorrect card number. Please re-enter'))
    }
  }

  jumpToMenu() {
    this.$router.push(`/v/${this.venueId}/tab-admin/${this.tabId}/menu`)
  }

  _setDetail() {
    const detail = {
      name: this.valueFields.name,
      phone: this.valueFields.phone,
      email: this.valueFields.email,
      openDateTime: {
        date: _setFormatDate(this.valueFields.date),
        time: _setFormatTime(this.valueFields.time)
      },
      minAmount: this.valueFields.minAmount,
      tabAmount: this.valueFields.tabAmount,
    }
    const { token, ...paymentDetail } = this.valueFields
    detail.paymentDetail = {
      type: 'creditCard',
      // '' when the card on file is kept (the backend does not store or return the CVC)
      cvc: paymentDetail.cvc || '',
      name: paymentDetail.cardName,
      cardNumber: paymentDetail.cardNumber,
      expireMonth: paymentDetail.cardExpiry.split(' / ')[0],
      expireYear: paymentDetail.cardExpiry.split(' / ')[1],
    }
    return detail
  }

  async _postTabDetail() {
    return await getTabDetail({
      venueId: this.venueId,
      tabId: this.tabId,
      passCode: this.tabPassCode,
    }).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
      this.showLoading = false
    })
  }
}

export default TabUpdate
</script>
